module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Day":"Day","Month":"Month"},"vi":{"Day":"Ngày","Month":"Tháng"}}')
  delete Component.options._Ctor
}
